import React from "react";
import "./Footer.scss";

import logo from "../../assets/img/logo.svg";

import vk from "./assets/img/vk.svg";
import inst from "./assets/img/inst.svg";
import fb from "./assets/img/fb.svg";
import yt from "./assets/img/yt.svg";

import personal from "../../assets/personal.pdf";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-wrapper">
          <a
            href="http://bit.ly/splat_logo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="Логотип SPLAT" className="logo footer__logo" />
          </a>
          <div className="footer-info">
            <a
              className="footer-info__item"
              href={personal}
              target="_blank"
              rel="noopener noreferrer"
            >
              Политика конфиденциальности
            </a>
            <a
              className="footer-info__item"
              href="mailto:actions@splat.ru"
              target="_blank"
              rel="noopener noreferrer"
            >
              Напишите нам
            </a>
          </div>

          <div className="footer-socials">
            <a className="footer-socials__item" href="https://clc.am/dtSVtw">
              <img src={vk} alt="Vkontakte" />
            </a>
            <a className="footer-socials__item" href="https://clc.am/6gHxQQ">
              <img src={inst} alt="Instagram" />
            </a>
            <a className="footer-socials__item" href="https://clc.am/BNyw1w">
              <img src={fb} alt="Facebook" />
            </a>
            <a className="footer-socials__item" href="https://clc.am/TXyACg">
              <img src={yt} alt="YouTube" />
            </a>
          </div>
          <span>© SPLAT 2021</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
